import React, { Fragment } from 'react';
import styled from 'styled-components';
import { CELL_SPACING, HeaderCell } from './shared';
import type { SearchMenuColumn } from 'venn-components';
import { ColumnRenderers } from './Columns';
import { cn } from '@/lib/utils';

const TableWrapper = styled.div`
  position: relative;
`;

const Table = styled.table`
  width: 100%;
  table-layout: auto;
  white-space: nowrap;
  text-align: left;
  font-size: 12px;
  tbody {
    tr {
      td {
        padding-right: ${CELL_SPACING}px;
      }
    }
  }
  thead {
    tr {
      th {
        padding-right: ${CELL_SPACING}px;
      }
    }
  }
`;
export const MenuListComponents = {
  TableWrapper,
  Table,
  HeaderRow: ({
    children,
    hasAddInvestmentRedesign = false,
  }: {
    children: React.ReactNode;
    hasAddInvestmentRedesign?: boolean;
  }) => (
    <thead className="qa-menu-header">
      <tr
        className={cn(
          hasAddInvestmentRedesign &&
            '[&_th]:border-0 [&_th]:border-y [&_th]:border-solid [&_th]:border-y-venn-grey-30 [&_th]:py-[8px]',
          hasAddInvestmentRedesign && 'first:*:pl-[16px] last:*:pr-[16px]',
        )}
      >
        <th className="empty-cell" />
        {children}
      </tr>
    </thead>
  ),
  FirstHeaderCell: ({ children }: { children: React.ReactNode }) => <FirstHeaderCell>{children}</FirstHeaderCell>,
  HeaderColumns: ({ columns }: { columns: SearchMenuColumn[] }) => {
    return columns.map((col) => <Fragment key={col}>{ColumnRenderers[col].headerRenderer()}</Fragment>);
  },
};

const FirstHeaderCell = ({ children, className, ...rest }: React.HTMLProps<HTMLTableCellElement>) => (
  <HeaderCell className={cn('text-left', className)} {...rest}>
    {children}
  </HeaderCell>
);
